import { render } from "./initialStockForm.vue?vue&type=template&id=7897ecd8&scoped=true"
import script from "./initialStockForm.vue?vue&type=script&lang=js"
export * from "./initialStockForm.vue?vue&type=script&lang=js"

import "./initialStockForm.vue?vue&type=style&index=0&id=7897ecd8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7897ecd8"]])

export default __exports__